import api from './api';

export const searchSpecies = (q, params = {}) =>
  api.get('/api/species', { params: { q, ...params } });

export const searchArchivedSpecies = (q, params = {}) =>
  api.get('/api/species/archived', { params: { q, ...params } });

export const getSpecies = (id) =>
  api.get(`/api/species/${id}`);

export const createSpecies = (data) =>
  api.post('/api/species', data);

export const importSpecies = (species) =>
  api.post('/api/species/import', { species });

export const updateSpecies = (id, data) =>
  api.patch(`/api/species/${id}`, data);

export const listSpeciesAdmin = (params) =>
  api.get('/api/species/admin', { params });
